import * as userRequest from "@/utils/userRequest";

export default async function getConnectedSocialsService(
  token: string,
  onSuccess?: (data?: any) => any,
  handleError?: (err?: any) => any
) {
  try {
    const res = await userRequest.get("auth/accounts", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (res) {
      onSuccess && onSuccess(res);
      return res;
    }
  } catch (err) {
    console.error("🚀 ~ getConnectedSocialsService ~ err:", err);
    handleError && handleError(err);
    throw err;
  }
}
